import { AutocompleteServiceOptions } from './AutocompleteServiceOptions';
import { GoogleAutocompleteService } from './GoogleAutocompleteService';
require('script-loader!.tmp/js/templates/components/autocomplete/Autocomplete.js');

const GoogleAutocompleteResultTypes = Object.freeze({
  GEOCODE: 'geocode',
  ADDRESS: 'address',
  ESTABLISHMENT: 'establishment',
  REGIONS: 'regions',
  CITIES: 'cities'
});

class GoogleAutocompleteServiceOptions extends AutocompleteServiceOptions {
  constructor (options) {
    super(options);
    this.types = [GoogleAutocompleteResultTypes.GEOCODE];
    this.strictBounds = false;
    this.radius = null;

    const soyString = components.Autocomplete.googleAttribution({
      darkMode : false,
      baseUrl : Yext.BaseUrl
    });
    this.attribution = document.createRange().createContextualFragment(soyString);
    this.attrEl = this.attribution.querySelector('.c-Autocomplete-placesAttrEl');
  }

  withRadius(radius) {
    this.radius = radius;
    return this;
  }

  withTypes(type) {
    this.types = type;
    return this;
  }

  withStrictBounds(bool) {
    this.strictBounds = bool;
    return this;
  }

  build() {
    if (!this.userLocationInfo) {
      throw new Error('a UserLocationInfo instance is required');
    }
    if(this.countryRestrictions > 5) {
      throw new Error('Max Number of restrictions is 5');
    }
    return new GoogleAutocompleteService(this);
  }
}

export {
  GoogleAutocompleteServiceOptions
};
